import React from "react";
import { Button, Tooltip } from "design-system";

export const ApiDocButton = ({ url }: { url: string }) => {
  return (
    <Tooltip
      content='访问API平台'
      placement="bottom"
    >
      <Button
        className="t--application-book-line-btn"
        kind="tertiary"
        onClick={() => url && window.open(url)}
        size="md"
        startIcon="book-line"
      >
        API文档
      </Button>
    </Tooltip>
  );
};
